module.exports = __webpack_public_path__ + "static/media/cover_page_t4.b54217c7.png";